import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiArrowForward = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M15 19L13.575 17.6L18.175 13H2V11H18.175L13.575 6.4L15 5L22 12L15 19Z" />
  </SvgWrapper>
);
